import SkeletonBase from "./SkeletonBase"

/**
 * Skeleton pour WebinarListItem
 * Reproduit la structure de WebinarListItem.jsx
 */
export default function WebinarListItemSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden animate-pulse">
      <div className="flex flex-col md:flex-row">
        {/* Image skeleton */}
        <div className="relative w-full md:w-64 h-48 md:h-auto flex-shrink-0">
          <SkeletonBase 
            className="w-full h-full" 
            rounded="rounded-none"
          />
          {/* Badge skeleton */}
          <div className="absolute top-3 left-3">
            <SkeletonBase 
              className="w-16 h-6" 
              width="4rem"
              height="1.5rem"
              rounded="rounded-full"
            />
          </div>
        </div>

        {/* Content skeleton */}
        <div className="flex-1 p-6 flex flex-col">
          {/* Header */}
          <div className="mb-4">
            <SkeletonBase 
              className="h-6 mb-2" 
              height="1.5rem"
            />
            <SkeletonBase 
              className="h-6 w-4/5 mb-2" 
              width="80%"
              height="1.5rem"
            />
            <div className="space-y-2 mt-2">
              <SkeletonBase 
                className="h-4" 
                height="1rem"
              />
              <SkeletonBase 
                className="h-4 w-3/4" 
                width="75%"
                height="1rem"
              />
            </div>
          </div>

          {/* Info skeleton */}
          <div className="flex flex-wrap gap-4 mb-4">
            <SkeletonBase 
              className="w-32 h-4" 
              width="8rem"
              height="1rem"
            />
            <SkeletonBase 
              className="w-24 h-4" 
              width="6rem"
              height="1rem"
            />
            <SkeletonBase 
              className="w-28 h-4" 
              width="7rem"
              height="1rem"
            />
            <div className="flex items-center space-x-2">
              <SkeletonBase 
                className="w-5 h-5 rounded-full" 
                width="1.25rem"
                height="1.25rem"
                rounded="rounded-full"
              />
              <SkeletonBase 
                className="w-20 h-4" 
                width="5rem"
                height="1rem"
              />
            </div>
          </div>

          {/* Actions skeleton */}
          <div className="flex flex-wrap gap-2 mt-auto">
            <SkeletonBase 
              className="w-32 h-10" 
              width="8rem"
              height="2.5rem"
              rounded="rounded-md"
            />
            <SkeletonBase 
              className="w-28 h-10" 
              width="7rem"
              height="2.5rem"
              rounded="rounded-md"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
